import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71b70320"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionView" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "bo" }, "欢迎来到MYOJ！", -1))
const _hoisted_3 = { class: "card" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import { MyAxios } from "@/plugins/axios";
import { useRouter } from "vue-router";
import moment from "moment-timezone/moment-timezone-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionView',
  setup(__props) {

const router = useRouter();
const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  current: 1,
  pageSize: 10,
  title: "",
  tags: [],
  id: "",
});
const form = ref({
  ...searchParams.value,
});

/**
 * 加载数据
 */
const loadData = async () => {
  await MyAxios.post("/question/list/page/vo", searchParams.value).then(
    (res) => {
      if (res.data.code === 0) {
        dataList.value = res.data.data.records;
        total.value = res.data.data.total;
        // console.log(res.data.data);
      } else {
        message.error("加载失败：" + res.data.message);
      }
    }
  );
};
const calculateAcRate = (record: any) => {
  let rate = !record.submitNum ? "0" : record.acceptNum / record.submitNum;
  rate = Number(rate) * 100;
  return (
    rate.toFixed(2) + "% (" + record.acceptNum + "/" + record.submitNum + ")"
  );
};
const timeFormat = (time: any) => {
  return moment(time).tz("Asia/Shanghai").format("YYYY-MM-DD");
};
onMounted(() => {
  loadData();
});
watchEffect(() => {
  loadData();
});

const changePageNum = (current: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: current,
  };
};
const changePageSize = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: pageSize,
  };
};
const doSearch = () => {
  searchParams.value = {
    ...searchParams.value,
    id: form.value.id,
    title: form.value.title,
    tags: form.value.tags,
    current: 1,
  };
};
const toDetailPage = (record: any) => {
  router.push({
    path: "./detail/question",
    query: {
      id: record.id,
    },
  });
};

const columns = [
  {
    title: "题号",
    dataIndex: "id",
  },
  {
    title: "题目名称",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tags",
  },
  // {
  //   title: "通过率",
  //   slotName: "acRate",
  // },
  {
    title: "创建时间",
    slotName: "createTime",
  },
  {
    slotName: "detail",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_tag = _resolveComponent("a-input-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_form, {
        model: form.value,
        layout: "inline",
        class: "bo"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "题目名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
                placeholder: "请输入题目名称",
                style: {"min-width":"240px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "标签" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_tag, {
                modelValue: form.value.tags,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.tags) = $event)),
                placeholder: "请输入标签(回车确认)",
                style: {"min-width":"240px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "题号" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: form.value.id,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.id) = $event)),
                placeholder: "请输入题号",
                style: {"min-width":"240px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: doSearch,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_a_table, {
        columns: columns,
        data: dataList.value,
        pagination: {
          showTotal: true,
          pageSize: searchParams.value.pageSize,
          current: searchParams.value.current,
          total: total.value,
          showPageSize: true,
          showJumper: true,
        },
        onPageChange: changePageNum,
        onPageSizeChange: changePageSize
      }, {
        tags: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
                return (_openBlock(), _createBlock(_component_a_tag, {
                  color: "#7bc616",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]),
        acRate: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tag, { color: "#0fc6c2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(calculateAcRate(record)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        createTime: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(timeFormat(record.createTime)), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        detail: _withCtx(({ record }) => [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: ($event: any) => (toDetailPage(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("详情 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data", "pagination"])
    ])
  ]))
}
}

})